// [PROSPEK] 2026-06-11 media quick replies - normalize selected canned response text and media.
export const resolveCannedResponseSelection = response => ({
  content: response.content || response.description || '',
  attachments: Array.isArray(response.attachments) ? response.attachments : [],
});
// [/PROSPEK]
